import script from "./SearchResult.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchResult.vue?vue&type=script&setup=true&lang=js"

import "./SearchResult.vue?vue&type=style&index=0&id=1ad85eb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ad85eb8"]])

export default __exports__